import React from 'react';
import { Link } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { Button } from './ui/button';
import { formatFestivalDateRange } from '../data/festivals';

const markerIcon = new L.Icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

export const FestivalMapPlaceholder = ({ festivals = [] }) => {
  return (
    <section className="pb-20 md:pb-24">
      <div className="container-custom">
        <div className="overflow-hidden rounded-2xl bg-white shadow-sm">
          <MapContainer
            center={[56.2639, 9.5018]}
            zoom={7}
            scrollWheelZoom={false}
            className="h-[520px] w-full"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {festivals.map((festival) => (
              <Marker
                key={festival.id}
                position={[festival.lat, festival.lng]}
                icon={markerIcon}
              >
                <Popup>
                  <div className="min-w-[220px]">
                    <div className="text-base font-semibold text-foreground">{festival.name}</div>
                    <div className="mt-2 text-sm text-body-text">
                      {festival.city}, {festival.region}
                    </div>
                    <div className="mt-1 text-sm text-body-text">
                      {formatFestivalDateRange(festival.startDate, festival.endDate)}
                    </div>
                    <div className="mt-3 flex flex-wrap gap-2">
                      <Button asChild size="sm" className="h-8 rounded-lg px-3">
                        <Link to={`/festival/${festival.id}`}>Se festival</Link>
                      </Button>
                      {festival.website && (
                        <Button asChild size="sm" variant="outline" className="h-8 rounded-lg border-primary/20 bg-white px-3 text-primary hover:bg-white">
                          <a href={festival.website} target="_blank" rel="noopener noreferrer">
                            Officiel side
                          </a>
                        </Button>
                      )}
                    </div>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </section>
  );
};
